import { apiPost, apiGet, apiDelete, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getPricingTemplatesAPI = (pricingTemplateId) => {
  return apiGet(`mgmt/products/pricingTemplates`)
}

export const createPricingTemplateAPI = (pricingTemplate) => {
  Hotjar.event('create_pricing_template')
  return apiPost(`mgmt/products/pricingTemplate`, pricingTemplate)
}

export const updatePricingTemplateAPI = (pricingTemplate) => {
  Hotjar.event('update_pricing_template')
  return apiPut(`mgmt/products/${pricingTemplate.id}/pricingTemplate`, pricingTemplate)
}

export const getPricingTemplateByIdAPI = (pricingTemplateId) => {
  return apiGet(`mgmt/products/${pricingTemplateId}/pricingTemplate`)
}

export const deletePricingTemplateAPI = (pricingTemplateId) => {
  Hotjar.event('delete_pricing_template')
  return apiDelete(`mgmt/products/${pricingTemplateId}/pricingTemplate`)
}

export const getWeightTolerancesAPI = () => {
  return apiGet(`mgmt/inventory/tolerances`)
}

export const getPriceBreaksAPI = (weightPerUnit) => {
  return apiGet(`mgmt/products/pricingTemplates/priceBreaks`, { weightPerUnit })
}



// WEBPACK FOOTER //
// ./src/api/pricingTemplate.js